import { Timestamp } from "firebase/firestore";
import {
  createDate,
  getInitWorkoutFormModel,
  InputTypes,
  WorkoutFormModel,
} from "../lib/workout-form/transformers";
import { Workout } from "../providers/workouts";
import {
  creditsValidator,
  dateValidator,
  endTimeValidator,
  gearValidator,
  locationValidator,
  numberOfPlacesValidator,
  startTimeValidator,
  typeValidator,
} from "../lib/workout-form/validators";
import { PublicUser } from "../providers/users";

export enum FormInputs {
  title = "TITLE",
  type = "TYPE",
  body = "BODY",
  gear = "GEAR",
  date = "DATE",
  numberOfPlaces = "NUMBEROFPLACES",
  participantsCount = "PARTICIPANTSCOUNT",
  startTime = "STARTTIME",
  endTime = "ENDTIME",
  location = "LOCATION",
  credits = "CREDITS",
  collectionTime = "COLLECTIONTIME",
  registrationTime = "REGISTRATIONTIME",
  clear = "CLEAR",
  coaches = "COACHES",
}

export const initWorkout: Workout = {
  id: "",
  admin: {
    uid: "",
    displayName: "",
    email: "",
    phone: "",
    photoURL: "",
  },
  type: "circletraining",
  body: "",
  gear: [],
  numberOfPlaces: 0,
  participantsCount: 0,
  participantsList: [],
  waitlistCount: 0,
  waitlist: [],
  coaches: [],
  title: "",
  createdAt: Timestamp.now(),
  updatedAt: Timestamp.now(),
  date: Timestamp.now(),
  startTime: Timestamp.now(),
  endTime: Timestamp.now(),
  location: "",
  credits: 0,
  collectionTime: 0,
  registrationTime: 0,
};

export type Action = {
  type: FormInputs;
  payload: InputTypes;
};

export default function UseWorkoutFormReducer(
  state: WorkoutFormModel,
  action: Action
): WorkoutFormModel {
  const { type, payload } = action;
  switch (type) {
    case FormInputs.type:
      state[FormInputs.type].input = payload as string;
      typeValidator(state);
      return {
        ...state,
      };
    case FormInputs.title:
      state[FormInputs.title].input = payload as string;
      return {
        ...state,
      };
    case FormInputs.body:
      state[FormInputs.body].input = payload as string;
      return {
        ...state,
      };
    case FormInputs.gear:
      state[FormInputs.gear].input = payload as string[];
      gearValidator(state);
      return {
        ...state,
      };
    case FormInputs.coaches:
      state[FormInputs.coaches].input = payload as PublicUser[];
      return {
        ...state,
      };
    case FormInputs.numberOfPlaces:
      numberOfPlacesValidator(state);
      state[FormInputs.numberOfPlaces].input = payload as string;
      return {
        ...state,
      };
    case FormInputs.startTime:
      if (!payload) {
        return state;
      } else {
        const startTime = payload as Date;
        state[FormInputs.startTime].input = startTime;
        startTimeValidator(state);
        endTimeValidator(state);

        return {
          ...state,
        };
      }
    case FormInputs.endTime:
      if (!payload) {
        return state;
      } else {
        const endTime = payload as Date;
        state[FormInputs.endTime].input = endTime;
        startTimeValidator(state);
        endTimeValidator(state);
        return {
          ...state,
        };
      }
    case FormInputs.date:
      if (!payload) {
        return state;
      }
      const date = payload as Date;
      dateValidator(state);
      const updatedDateStartTime = createDate(
        date,
        state[FormInputs.startTime].input as Date
      );
      const updatedDateEndTime = createDate(
        date,
        state[FormInputs.endTime].input as Date
      );
      state[FormInputs.startTime].input = updatedDateStartTime;
      state[FormInputs.endTime].input = updatedDateEndTime;
      state[FormInputs.date].input = date;
      return {
        ...state,
      };
    case FormInputs.registrationTime:
      state[FormInputs.registrationTime].input = payload as number;
      return {
        ...state,
      };
    case FormInputs.collectionTime:
      state[FormInputs.collectionTime].input = payload as number;
      return {
        ...state,
      };
    case FormInputs.location:
      locationValidator(state);
      state[FormInputs.location].input = payload as string;
      return {
        ...state,
      };
    case FormInputs.credits:
      creditsValidator(state)
      state[FormInputs.credits].input = payload as number;
      return {
        ...state
      };
    case FormInputs.clear:
      return getInitWorkoutFormModel();
    default:
      return state;
  }
}
